import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import z from "zod";

const stockBalanceBuyablesToggleForProviderCommandZodSchema = z.object({
    _type: z.literal("STOCK_BALANCE_BUYABLES_TOGGLE_FOR_PROVIDER_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    enabled: z.boolean(),
});

type StockBalanceBuyablesToggleForProviderCommand = z.infer<
    typeof stockBalanceBuyablesToggleForProviderCommandZodSchema
>;

type FactoryParams = Except<
    StockBalanceBuyablesToggleForProviderCommand,
    "_type" | "_createdAt"
>;
const stockBalanceBuyablesToggleForProviderCommandFactory = (
    params: FactoryParams,
): StockBalanceBuyablesToggleForProviderCommand => {
    return {
        ...params,
        _type: "STOCK_BALANCE_BUYABLES_TOGGLE_FOR_PROVIDER_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};
export {
    stockBalanceBuyablesToggleForProviderCommandFactory,
    stockBalanceBuyablesToggleForProviderCommandZodSchema,
};
export type { StockBalanceBuyablesToggleForProviderCommand };
